import { debounce } from 'lodash';
import { compose, withProps, withState, withHandlers, lifecycle } from 'recompose';

const SearchInputContainer = compose(
  withProps(props => ({
    debouncedSetSearchTerm: debounce(props.setSearchTerm, 300),
  })),
  withState('value', 'setValue', ''),
  withHandlers({
    onChange: props => (event) => {
      const value = event.target.value;

      props.setValue(value);
      props.debouncedSetSearchTerm(value);
      if (props.onChange) {
        props.onChange();
      }
    },
  }),
  withHandlers({
    onClear: props => () => {
      props.onChange({ target: { value: '' } });
    },
  }),
  lifecycle({
    componentWillUnmount() {
      this.props.onClear();
    },
  }),
);

export default SearchInputContainer;
